import { Deferred } from './DeferredPromise';

export class PossibleDeferred {
  private active?: Deferred;

  public start() {
    if (this.active) {
      throw new Error('Already have an active Deferred');
    }
    this.active = new Deferred();
  }

  public done(data: any) {
    this.active?.resolve(data);
    this.active = undefined;
  }

  public failed(err: Error) {
    this.active?.reject(err);
    this.active = undefined;
  }

  public async wait(): Promise<any|undefined> {
    if (!this.active) {
      return;
    }

    return await this.active.promise;
  }
}
